import CreateDeficiencyPage from "@features/deficiencies/create/CreateDeficiencyPage";
import DeficienciesDetails from "@features/deficiencies/deficiencies-details/DeficienciesDetails";
import DeficienciesContainer from "@features/deficiencies/DeficienciesContainer";
import DeficienciesPage from "@pages/deficiencies/DeficienciesPage";
import { paths } from "@utils/navigation";
import { type AppRoute } from "../types";

const buildDeficienciesRoute = (path: string): AppRoute => ({
  path,
  protected: true,
  requiredPermissions: ["hasFottDeficiencyAccess"],
  element: <DeficienciesPage />,
  children: [
    { index: true, element: <DeficienciesContainer /> },
    { path: paths.deficiencies.create, element: <CreateDeficiencyPage /> },
    {
      path: paths.deficiencies.deficienciesDetails,
      element: <DeficienciesDetails />,
    },
  ],
});

export const getDeficienciesRoute = (): AppRoute =>
  buildDeficienciesRoute(paths.deficiencies.index);
